// extracted by mini-css-extract-plugin
export default {"loader":"appLoader_loader__vDrAp","appear":"appLoader_appear__y8b09","spinner":"appLoader_spinner__qtb8W","spin":"appLoader_spin__LwbyB","srOnly":"appLoader_srOnly__OKS5q"};